<template>
  <div class="broadcast_container" v-if="broadcastData && broadcastData.length !== 0">
    <CardTitle
      :title="data.title"
      :skipPage="'/broadcast?dataJumpCategoryIds=' + dataJumpCategoryIds + '&dataShowRule=' + dataShowRule"
    />

    <div class="list_wrapper">
      <div class="list_item" v-for="item in broadcastData" :key="item.id" @click="skipHandle(item)">
        <div class="item_img">
          <img class="img" :src="item.coverImgUrl" />
        </div>

        <div class="item_content">
          <p class="content_title">{{ item.title }}</p>
          <p class="content_author">{{ item.author }}</p>
          <div class="content_label">
            <p class="label_time">{{ item.releaseTime }}</p>
            <span class="label_count">
              <i class="iconfont icon-icon_shouye_guankanrenshu" />
              {{ item.viewCount }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import CardTitle from './CardTitle.vue'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useRouter } from 'vue-router'
import { addViewCountReq, addUvCountReq } from '@/api/requests/BroadRequests'
import { sandsTalkNativeUrl, sandsTalkVnNativeUrl } from '@/utils/sandsTalkNative'
import { isSandsTalkPhOutfieldApp, sandsTalkPhOpenUrl } from '@/utils/sandsTalkPhOutfiled'
import { isWisdomRabbitApp, wisdomRabbitGoToNativeLoadUrl } from '@/utils/sandsTalkSmartRabbit'
import { brMexOutFieldNativeUrl, isSandsTalkBrMexApp } from '@/utils/sandsTalkBRMXOutfiled'
import { branchManagerGoToNativeLoadUrl, isBranchManagerApp } from '@/utils/sandsTalkBranchManager'
import { isIOS } from '@/utils/Device'
import { isSandsTalkMSFlutterApp, sandsTalkMSOpenUrl } from '@/utils/sandsTalkMSFlutter'
const SandsTalkUserInfo = JSON.parse(localStorage.getItem('SandsTalkUserInfo') || '{}')

const props = defineProps<{
  data: LmsDecorateModule
}>()

const router = useRouter()
interface TItem {
  id: string
  articleType: number
  jumpUrl: string
}
const skipHandle = async (item: TItem) => {
  addUvCountReq({
    id: item.id
  })
  if (item.articleType === 1 && item.jumpUrl && item.jumpUrl.length > 0) {
    try {
      const res = await addViewCountReq({ id: item.id })
      if (res?.code === 1) {
        // 行业动态 泰国外场
        if (SandsTalkUserInfo.source === 'ThOutfield') {
          sandsTalkNativeUrl(item.jumpUrl)
        } else if (isWisdomRabbitApp) {
          wisdomRabbitGoToNativeLoadUrl(item.jumpUrl)
        } else if (isBranchManagerApp) {
          // 网点管家
          branchManagerGoToNativeLoadUrl(item.jumpUrl)
        } else if (isSandsTalkPhOutfieldApp) {
          // 菲律宾外场
          sandsTalkPhOpenUrl(item.jumpUrl)
        } else if (window.jt || (!window.jt && window.flutter_inappwebview)) {
          // 越南外场
          sandsTalkVnNativeUrl(item.jumpUrl)
        } else if (isSandsTalkBrMexApp) {
          // 巴西和墨西哥外场
          if (isIOS) {
            brMexOutFieldNativeUrl(item.jumpUrl)
          } else {
            window.location.href = item.jumpUrl
          }
        } else if (isSandsTalkMSFlutterApp) {
          // 马来 兔学堂
          sandsTalkMSOpenUrl(item.jumpUrl)
        } else {
          window.location.href = item.jumpUrl
        }
      }
    } catch (error) {
      console.error('Error adding view count:', error)
    }
  } else {
    router.push('/broadcastDetail/' + item.id)
  }
}
const broadcastData = computed(() => {
  try {
    // console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})

const dataJumpCategoryIds = computed(() => {
  try {
    return props.data.lmsDecorateModuleCategories[0].dataJumpCategoryIds.join(',')
  } catch (error) {
    return ''
  }
})

const dataShowRule = computed(() => {
  try {
    return props.data.lmsDecorateModuleCategories[0].dataShowRule
  } catch (error) {
    return '0'
  }
})
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');

.broadcast_container {
  margin: 12px 16px;
  padding: 0 12px;
  background-color: @contentBackground;
  border-radius: 8px;
  .list_wrapper {
    .list_item {
      padding: 14px 0;
      display: flex;
      align-items: center;
      .border_1px_b;
      .item_img {
        width: 120px;
        height: 68px;
        border-radius: 5px;
        overflow: hidden;
        .flex_center;
        .img {
          width: 100%;
        }
      }
      .item_content {
        width: 0;
        flex: 1;
        margin-left: 10px;
        .content_title {
          font-size: 14px;
          .text_etc;
        }
        .content_author {
          margin-top: 10px;
          color: @textNormal;
          font-size: 12px;
        }
        .content_label {
          display: flex;
          justify-content: space-between;
          margin-top: 4px;
          .label_time {
            color: @textSecondary99;
            font-size: 12px;
          }
          .label_count {
            font-size: 12px;
            color: @textNormal;
            .iconfont {
              font-size: 12px;
              color: @textSecondary99;
            }
          }
        }
      }
    }
  }
}
</style>
